<template>
  <div class="search">
    <nav class="navbar navbar-expand-lg navbar-light">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo01"
        aria-controls="navbarTogglerDemo01"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
        <a class="navbar-brand" href="#">SmartLab</a>
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="nav-item active"></li>
          <li class="nav-item"></li>
          <li class="nav-item"></li>
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <button class="btn btn-outline-light btn-lg my-2 my-sm-0 ml-5 mr-2" type="submit">Search</button>
          <button class="btn btn-light btn-lg my-2 my-sm-0 ml-2 mr-5" type="submit">Register</button>
        </form>
      </div>
    </nav>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>